import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs } from 'antd';
import { useSelector } from 'react-redux';
import ManagersTab from './ManagersTab';
import AccessControlListTab from './AccessControlListTab';
import BusinessManagersView from './BusinessManagersView';
import usePermissions from '../../../hooks/auth/usePermissions';
import { selectCurrentFranchiseId } from '../../../store/slices/CurrentFranchiseSlice';

export const managers_tab = 'managers';
export const access_control_list_tab = 'access_control_list';

export default function ManagersView() {
  const { t } = useTranslation(undefined, { keyPrefix: 'Views:Team:Managers:ManagersView' });
  const { isSuperAdmin, isAdmin, isMerchant } = usePermissions();
  const companyFranchiseId = useSelector((state) => state.currentCompany.company?.franchise_id);
  const selectedFranchiseId = useSelector(selectCurrentFranchiseId);
  const hasSelectedFranchise = isMerchant ? (selectedFranchiseId ?? companyFranchiseId) : companyFranchiseId;

  if (hasSelectedFranchise) {
    return <BusinessManagersView />;
  }

  // Admins manage their own provider's team; the ACL tab stays super-admin-only.
  if (!isSuperAdmin && !isAdmin) {
    return null;
  }

  const items = [
    {
      key: managers_tab,
      label: t(`tabs.${managers_tab}`),
      children: <ManagersTab />,
    },
    ...(isSuperAdmin
      ? [
          {
            key: access_control_list_tab,
            label: t(`tabs.${access_control_list_tab}`),
            children: <AccessControlListTab />,
          },
        ]
      : []),
  ];

  return <Tabs defaultActiveKey={managers_tab} items={items} />;
}
